















import { Component, Vue, Prop } from "vue-property-decorator";
import { LicenseModel } from "../models";
import ModuleList from "./ModuleList.vue";
import { Module } from "../types";
import mods from "../static/modules";

@Component({ components: { ModuleList } })
export default class CompleteModules extends Vue {
  @Prop({ required: true })
  license!: LicenseModel;

  modules: Module[] = Object.entries(mods)
    .map(pair => pair[1])
    .filter(mod => mod.bundle === "complete");
}
